<template>
<div class="item" ref="item">
    <a :href="link" class="img" target="_blank" draggable="false">
        <img :src="img" :id="`item-${id}`" draggable="false">
        <img :src="hoverImg" :id="`item-${id}`" draggable="false">
    </a>
    <h3 class="title">
        <a
            :href="link"
            target="_blank"
            draggable="false"
            :data-detail="link"
            :data-name="title"
        >
            <span :data-detail="link" :data-name="title">{{ title }}</span>
            <Icon
                type="right"
                :data-detail="link"
                :data-name="title"/>
        </a>
    </h3>

    <template v-for="obj in linkObjs">
        <p :key="obj.url" class="text" >
            <a
                :href="obj.url"
                target="_blank"
                draggable="false"
                :data-detail="obj.url"
                :data-name="`${title}-${obj.text}`">{{obj.text}}</a>
        </p>
    </template>
    <div v-html="htmlContent"/>
</div>

</template>
<script>
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Icon } from '@gaoding/gd-antd';
export default {
  components: {
    Icon
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    img: {
      type: String,
      required: true
    },
    hoverImg: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    titleColor: {
      type: String,
      required: true
    },
    linkObjs: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      htmlContent: ''
    };
  },

  mounted() {
    this.setImgHoverStyle();
  },

  methods: {
    setImgHoverStyle() {
      this.htmlContent = "\n                <style>\n                    #item-" + this.id + ":hover {\n                        box-shadow: 0px 8px 12px -4px " + this.titleColor + "33;\n                    }\n                </style>\n            ";
    }

  }
};
</script>
<style scoped>
.item {
  position: relative;
}
.item a {
  text-decoration: none;
}
.item .img {
  display: inline-block;
  width: 144px;
  height: 103px;
  border-radius: 2px;
  top: 18px;
  transition: top 0.2s;
}
.item .img > img {
  width: 100%;
  height: 100%;
}
.item .img img:nth-child(2) {
  display: none;
}
.item .img:hover img:nth-child(1) {
  display: none;
}
.item .img:hover img:nth-child(2) {
  display: block;
}
.item .title {
  margin: 14px 0 18px;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
}
.item .title a {
  color: rgba(255, 255, 255, 0.8);
}
.item .title a span {
  line-height: 22px;
  vertical-align: top;
}
.item .title a /deep/ .g-icon--large {
  font-size: 24px;
}
.item .title a:hover {
  color: #fff;
}
.item .title a > i {
  display: inline-block;
  margin-top: 2px;
  font-size: 20px;
}
.item .text {
  margin: 0 0 12px 0;
  line-height: 20px;
}
.item .text a {
  font-size: 14px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.4);
}
.item .text a:hover {
  color: #fff;
}

</style>
